import { VersionCodeDetail } from "@src/features/agenticCodegen/workspace/components/VersionHistory/VersionCodeDetail";
import { decodeAgenticLogicFiles } from "./agenticLogicMonacoTypes";
import { useAgenticVersionDetail } from "./useAgenticVersionDetail";

/**
 * Runs the version-detail query and hands the shell the resolved read, rendered
 * inline inside an expanded version-history card. Keeping the query here is
 * what lets the shared view stay presentational — passing the hook itself as a
 * prop would trip rules-of-hooks.
 */
export const AgenticVersionCode = ({
  ruleId,
  version,
  readOnly,
}: {
  ruleId: string | undefined;
  version: number;
  readOnly: boolean;
}) => (
  <VersionCodeDetail
    version={version}
    versionDetail={useAgenticVersionDetail(ruleId, version)}
    decodeFiles={decodeAgenticLogicFiles}
    // There is no import-as-draft route for Agentic Logic, so the port supplies
    // no versionImport capability and the action is absent rather than inert.
    onImport={() => undefined}
    isImporting={false}
    canImport={false}
    readOnly={readOnly}
  />
);
